import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { COMMONS, LANDING } from './resources/es';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: {
          ...COMMONS,
          ...LANDING,
        },
      },
    },
  });

i18n.changeLanguage('es');
